<template>
    <div>
        <form>
            <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">R.F.C</label>
                        <input class="form-control" placeholder="" v-model="form.rfc" v-bind:class="formSubmitted ? errors.rfc ? 'is-invalid' : 'is-valid' : ''" @input="form.rfc = form.rfc.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.rfc">{{ errors.rfc }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">C.U.R.P</label>
                        <input class="form-control" placeholder="" v-model="form.curp" v-bind:class="formSubmitted ? errors.curp ? 'is-invalid' : 'is-valid' : ''" @input="form.curp = form.curp.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.curp">{{ errors.curp }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">N.S.S</label>
                        <input class="form-control" placeholder="" v-model="form.nss" v-bind:class="formSubmitted ? errors.nss ? 'is-invalid' : 'is-valid' : ''" @input="form.nss = form.nss.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.nss">{{ errors.nss }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">Fecha de Nacimiento</label>
                        <Datepicker class="datepicker-here form-control digits dp1" v-model="form.birthdate" v-bind:class="formSubmitted ? errors.birthdate ? 'is-invalid' : 'is-valid' : ''" :enable-time-picker="false" :locale="'es-MX'" format="dd/MM/yyyy"></Datepicker>
                        <div class="invalid-feedback" v-if="errors.birthdate">{{ errors.birthdate }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">
                    <div class="mb-3">
                        <label class="form-label">Dirección</label>
                        <input class="form-control" placeholder="" v-model="form.address" @input="form.address = form.address.toUpperCase()">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">Código Postal</label>
                        <input class="form-control" placeholder="" v-model="form.zipcode" v-bind:class="formSubmitted ? errors.zipcode ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.zipcode">{{ errors.zipcode }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Correo Electrónico</label>
                        <input class="form-control" placeholder="" v-model="form.email" v-bind:class="formSubmitted ? errors.email ? 'is-invalid' : 'is-valid' : ''" @input="form.email = form.email.toLowerCase()">
                        <div class="invalid-feedback" v-if="errors.email">{{ errors.email }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Teléfono (Whatsapp)</label>
                        <input class="form-control" placeholder="" v-model="form.phone" v-bind:class="formSubmitted ? errors.phone ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone }}</div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Contacto de Emergencia</span></div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Nombre</label>
                        <input class="form-control" placeholder="" v-model="form.contact_name" @input="form.contact_name = form.contact_name.toUpperCase()">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Teléfono</label>
                        <input class="form-control" placeholder="" v-model="form.contact_phone">    
                    </div>
                </div>
            </div>
            <div class="row" style="padding-bottom: 15px;">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="updateGeneralEmployee()">Guardar Información</button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations"; 
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import ws from '@/services/employees'

export default {
    name: 'employee_information_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    data(){
        return{
            employee: null
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;

            this.setForm(this.employee);
        },
        async updateGeneralEmployee() {
            console.log(this.form);
            let response = await ws.updateEmployee(this.form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        validations(){
            this.updateEmployeeInformationValidation();
        }
    }
}
</script>
<style>
    .dp1{
        input {
            height: 24px;
        }
    }
</style>